import { render } from "./date.vue?vue&type=template&id=09c4b58a&scoped=true"
import script from "./date.vue?vue&type=script&lang=js"
export * from "./date.vue?vue&type=script&lang=js"

import "./date.vue?vue&type=style&index=0&id=09c4b58a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3316487999/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c4b58a"]])

export default __exports__